import { LISTING_FORM_FIELD_NAME_FLAT } from '../../../../../../RentalPortalListing'

export const LISTING_PROFILE_BLOCK_SERVER_FIELD_NAME = {
  flat_id: LISTING_FORM_FIELD_NAME_FLAT,
}
